module.exports = __webpack_public_path__ + "img/相爱.eb24bf9c.jpeg";